import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import TextInput from 'components/atoms/form/TextInput/TextInput'
import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import FormModal from 'components/organisms/FormModal/FormModal'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import OnboardingContactService from 'services/OnboardingContactService'
import * as Yup from 'yup'
import * as FormConst from '../../constants/FormConst'
import RouteConst from '../../constants/RouteConst'
import { asyncMethod } from '../../redux/actions'
import * as actionTypes from '../../redux/actionTypes'
import { isArrayNotEmpty, removeHotelInfoFromSession, removeHotelOnboardingStatusFromSession, removeLockStatusFromSession, searchFirstObjectInList } from '../../utilities/JSUtil'
import './InitialOPDContact.scss'

class InitialOPDContact extends Component {

    constructor(props) {
        super(props)
        const hotelCode = this.props.history.location?.state?.hotelCode

        if (!hotelCode) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }
        removeHotelInfoFromSession()
        removeLockStatusFromSession()
        removeHotelOnboardingStatusFromSession()

        this.state = {
            hotelCode: hotelCode,
            initialValues: this.initialValues,
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false
        }
    }

    initialValues = {
        firstName: '',
        lastName: '',
        title: '',
        type: FormConst.HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR,
        phoneNumber: '',
        countryCode: '',
        areaCode: '',
        phoneNumberType: '',
        email: '',
        emailType: FormConst.VALUE_WORK
    }

    validationSchema = Yup.object().shape({
        firstName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        lastName: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        title: Yup.string()
            .max(FormConst.MAX_LENGTH_TITLE, `Maximum ${FormConst.MAX_LENGTH_TITLE} characters`),
        countryCode: Yup.string().test('Country code validation', function (val) {
            if ((!!this.parent.areaCode || !!this.parent.phoneNumber) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_COUNTRY_CODE, `Maximum ${FormConst.MAX_LENGTH_COUNTRY_CODE} digits`),
        areaCode: Yup.string().test('Area code validation', function (val) {
            if ((!!this.parent.countryCode || !!this.parent.phoneNumber) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_AREA_CODE, `Maximum ${FormConst.MAX_LENGTH_AREA_CODE} digits`),
        phoneNumber: Yup.string().test('Phone number validation', function (val) {
            if ((!!this.parent.areaCode || !!this.parent.countryCode) && !val) {
                return this.createError({ message: FormConst.VALIDATION_ERROR_REQUIRED })
            } else if (!this.parent.email && !val) {
                return this.createError({ message: 'Phone or email required' })
            }
            return true
        }).matches(FormConst.PATTERN_NUMBERS_ONLY, FormConst.VALIDATION_ERROR_NUMBERS_ONLY)
            .max(FormConst.MAX_LENGTH_PHONE_NUMBER, `Maximum ${FormConst.MAX_LENGTH_PHONE_NUMBER} digits`),
        phoneNumberType: Yup.string().when('phoneNumber', {
            is: (val) => val !== undefined && val !== '',
            then: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
        }),
        email: Yup.string()
            .matches(FormConst.EMAIL_PATTERN, 'Valid email required')
    })

    async componentDidMount() {
        let existingOnboardingContact
        // Retrieve hotel contacts
        await OnboardingContactService.getOnboardingContact({ hotelCode: this.state.hotelCode })
            .then(response => {
                if (isArrayNotEmpty(response.contacts)) {
                    const onboardingContactFromResponse = searchFirstObjectInList('type', FormConst.HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR, response.contacts)
                    if (onboardingContactFromResponse) {
                        existingOnboardingContact = {
                            ...this.state.initialValues,
                            firstName: onboardingContactFromResponse.firstName,
                            lastName: onboardingContactFromResponse.lastName,
                            title: onboardingContactFromResponse.title,
                            type: FormConst.HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR,
                            phoneNumber: '',
                            countryCode: '',
                            areaCode: '',
                            phoneNumberType: '',
                            email: '',
                            emailType: FormConst.VALUE_WORK
                        }

                        if (isArrayNotEmpty(onboardingContactFromResponse.phoneNumbers)) {
                            const existingPhoneNumber = onboardingContactFromResponse.phoneNumbers[0]
                            existingOnboardingContact.countryCode = existingPhoneNumber.countryCode
                            existingOnboardingContact.areaCode = existingPhoneNumber.areaCode
                            existingOnboardingContact.phoneNumber = existingPhoneNumber.number
                            existingOnboardingContact.phoneNumberType = existingPhoneNumber.type
                        }

                        if (isArrayNotEmpty(onboardingContactFromResponse.emailAddresses)) {
                            const existingEmail = onboardingContactFromResponse.emailAddresses[0]
                            existingOnboardingContact.email = existingEmail.address
                            existingOnboardingContact.emailType = existingEmail.type
                        }
                    }
                }
                this.setState({
                    isLoading: false,
                    initialValues: existingOnboardingContact ? existingOnboardingContact : this.initialValues
                })
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while retrieving Hotel Onboarding Contact data'
                })
            })
    }

    handleSubmit = (formData) => {
        const newEntry = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            title: formData.title,
            type: formData.type,
            phoneNumbers: formData.phoneNumber ? [{
                "areaCode": formData.areaCode,
                "countryCode": formData.countryCode,
                "number": formData.phoneNumber,
                "type": formData.phoneNumberType,
                "preferred": true
            }] : undefined,
            emailAddresses: formData.email ? [{
                "address": formData.email,
                "type": formData.emailType,
                "preferred": true
            }] : undefined,
        }
        const newHotelContacts = [newEntry]
        this.props.onPut({ hotelCode: this.state.hotelCode, contacts: newHotelContacts })
        this.setState({ isLoading: true, loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    resetFormData = (formikResetFormMethod) => {
        formikResetFormMethod()
        this.setState({
            showResetModal: false
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                })
            } else {
                // Go back to Home page
                this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
            }
        }
    }

    handleErrorModalCancel = () => {
        this.setState({ isLoading: false })
    }

    render() {
        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                }}>
                {
                    ({ isSubmitting, resetForm, handleChange }) => (
                        <Form className='hotel-opd-contact-initial-form-element'>
                            <p className='hotel-contact-type'>{FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR}</p>
                            <p className='helper-text'>Enter {FormConst.LABEL_HOTEL_CONTACT_TYPE_OPENING_SERVICE_DIRECTOR} details. ** Phone number or Email is required.</p>
                            <p className='hotel-opd-contact-helper-text'>Hotel Code: {this.state.hotelCode}</p>

                            <div className='hotel-opd-contact-initial-form-fields'>
                                <TextInput id='firstName' name='firstName' type='text' label='First Name' isrequired='true' />
                                <TextInput id='lastName' name='lastName' type='text' label='Last Name' isrequired='true' />
                                <TextInput id='title' name='title' type='text' label='Title' />
                                <TextInput id='phone-number' name='countryCode' type='tel' label='Phone Number' isdependent='true'
                                    placeholder='CC'
                                    suffix={
                                        <>
                                            <TextInput id='area-code' name='areaCode' label=' - ' type='num' title='Area Code' placeholder='Area Code' />
                                            <TextInput name='phoneNumber' type='tel' label=' - ' title='Phone Number' placeholder='Phone Number' />
                                        </>
                                    } />
                                <SelectInput id='phoneNumberType' name='phoneNumberType' type='tel' label='Phone Number Type' isdependent='true'
                                    options={FormConst.HOTEL_CONTACTS_PHONE_NUMBER_TYPES} />
                                <TextInput
                                    id='email'
                                    name='email'
                                    type='email'
                                    label='Email'
                                    title='Email (lowercase)'
                                    onChange={(e) => {
                                        e.preventDefault()
                                        if (e.target.value) {
                                            e.target.value = e.target.value.toLowerCase()
                                        }
                                        handleChange(e)
                                    }}
                                    isdependent='true' />
                            </div>

                            <FormFooter
                                form={
                                    {
                                        previous: { title: 'Home', route: RouteConst.ROUTE_HOME_PAGE }
                                    }
                                }
                                isSubmit
                                submitName={FormConst.SAVE_BUTTON_TEXT}
                                resetName={FormConst.RESET_BUTTON_TEXT}
                                onReset={this.handleClearForm}
                                submitDisabled={isSubmitting} />
                            <FormModal
                                id='hotel-contacts-page-loading-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='hotel-contacts-page-reset-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_RESET_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_RESET_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.resetFormData(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='hotel-contacts-page-error-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                show={this.state.showErrorModal}
                                cancel={() => { this.setState({ showErrorModal: false }) }} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        hotelContactsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_ONBOARDING_CONTACT_NAME, actionTypes.ASYNC_ACTIONS.PUT, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InitialOPDContact)